"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PatientDetailsNotes = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _utils = require("../../../utils");
var _components = require("../../../components");
var _ = require("../..");
var _PatientNoteUpsertDialog = require("./PatientNoteUpsertDialog");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var PatientDetailsNotes = function PatientDetailsNotes(_ref) {
  var patient = _ref.patient;
  var patientId = patient === null || patient === void 0 ? void 0 : patient.id;
  // Save just the ID instead of whole note
  // so that whole note is derived from ID
  // and UI displays most up-to-date note after refreshing notes
  // Also save isLegacyNote because `id` refers to patient_note.id in legacy notes
  // and booking.id in session notes, so uniqueness is not guaranteed
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    targetNoteProps = _useState2[0],
    setTargetNoteProps = _useState2[1];
  var _useRequest = (0, _utils.useRequest)((0, _utils.getPatientNotesUrl)(patientId), {
      ready: !!patientId
    }),
    notes = _useRequest.data,
    refreshNotes = _useRequest.refresh,
    loadingNotes = _useRequest.loading;
  // Apparently if `targetNoteProps` is undefined,
  // `find` returns the first element in the array instead of undefined :/
  var targetNote = targetNoteProps && (0, _lodash.find)(notes, targetNoteProps);
  var _useRequest2 = (0, _utils.useRequest)(function (data) {
      return {
        url: (0, _utils.getPatchLegacyNoteUrl)(patientId, (targetNote === null || targetNote === void 0 ? void 0 : targetNote.id) || ''),
        method: 'patch',
        data: data
      };
    }, {
      manual: true,
      onSuccess: function onSuccess() {
        _utils.toast.success({
          title: 'Appointment note saved!'
        });
      }
    }),
    updateLegacyNote = _useRequest2.runAsync,
    loadingUpdateLegacyNote = _useRequest2.loading;
  var noteCubby = (0, _utils.useModalState)();
  var handleAction = function handleAction(note) {
    setTargetNoteProps((0, _lodash.pick)(note, ['id', 'isLegacyNote']));
    noteCubby.show();
  };
  var handleCloseCubby = function handleCloseCubby() {
    noteCubby.hide();
    // Set timeout so that content is still visible
    // while cubby closing animation is playing
    setTimeout(function () {
      return setTargetNoteProps(undefined);
    }, _components.OVERLAY_ANIMATION_DURATION);
    refreshNotes();
  };
  return /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: loadingNotes
  }, /*#__PURE__*/_react.default.createElement(_.PatientNotesList, {
    notes: notes,
    showOwner: true,
    onAction: handleAction
  }), /*#__PURE__*/_react.default.createElement(_components.Cubby, {
    visible: noteCubby.visible,
    overlayStyles: "fixed top-0 right-0 w-screen h-screen z-cubby-overlay",
    cubbyStyles: "fixed bottom-0 right-0 h-[calc(100vh-theme(spacing.app-header-height))] w-[594px] z-cubby",
    onClose: handleCloseCubby
  }, targetNote ? (0, _utils.isLegacyNote)(targetNote) ? /*#__PURE__*/_react.default.createElement(_PatientNoteUpsertDialog.PatientNoteUpsertDialog, {
    note: targetNote,
    readonly: !(targetNote !== null && targetNote !== void 0 && targetNote.creator.owner),
    onSubmit: updateLegacyNote,
    patientId: patientId,
    loading: loadingUpdateLegacyNote
  }) : /*#__PURE__*/_react.default.createElement(_.VideoChatCubbyWrapper, {
    booking: targetNote,
    patient: targetNote === null || targetNote === void 0 ? void 0 : targetNote.patient,
    initialScreen: (0, _utils.getInitialVideoChatCubbyScreenFromNote)(targetNote)
  }, /*#__PURE__*/_react.default.createElement(_.VideoChatCubby, {
    showAppointmentCubby: false
  })) : null));
};
exports.PatientDetailsNotes = PatientDetailsNotes;